import { Share2, MessageCircle, Facebook, Twitter, Link as LinkIcon } from 'lucide-react';
import { toast } from 'sonner';
import { useState } from 'react';

/**
 * Pulsanti condivisione — usa Web Share API nativa quando possibile,
 * fallback a link diretti WhatsApp/Facebook/Twitter/Copy.
 */
export default function ShareButtons({ title, description, url, compact = false }) {
  const [open, setOpen] = useState(false);
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const text = `${title || 'AgriNexus'} — ${description || 'Scopri questo terreno agricolo'}`;

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text: description, url: shareUrl });
      } catch {} // user aborted
    } else {
      setOpen(o => !o);
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Link copiato');
    } catch { toast.error('Copia manualmente il link'); }
    setOpen(false);
  };

  const wa = `https://wa.me/?text=${encodeURIComponent(text + ' ' + shareUrl)}`;
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
  const tw = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(shareUrl)}`;

  if (compact) {
    return (
      <button data-testid="share-compact-btn" onClick={nativeShare} className="rounded-full p-2 hover:bg-secondary/50 transition-colors" title="Condividi">
        <Share2 size={14}/>
      </button>
    );
  }

  return (
    <div className="relative inline-block">
      <button onClick={nativeShare} data-testid="share-btn"
        className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-border text-sm hover:bg-secondary/40 transition-colors">
        <Share2 size={13}/> Condividi
      </button>
      {open && (
        <div className="absolute top-full right-0 mt-2 bg-card border border-border rounded-xl p-2 shadow-lg z-30 min-w-[200px]" data-testid="share-menu">
          <a href={wa} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-secondary/50 text-sm">
            <MessageCircle size={16} className="text-[#25D366]"/> WhatsApp
          </a>
          <a href={fb} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-secondary/50 text-sm">
            <Facebook size={16} className="text-[#1877F2]"/> Facebook
          </a>
          <a href={tw} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-secondary/50 text-sm">
            <Twitter size={16} className="text-[#1DA1F2]"/> X (Twitter)
          </a>
          <button onClick={copyLink} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-secondary/50 text-sm text-left">
            <LinkIcon size={16}/> Copia link
          </button>
        </div>
      )}
    </div>
  );
}
